var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classNames from "classnames";
import { Link } from "../../link/Link";
import { verticalMenuCls, verticalMenuAbsoluteCls, verticalMenuFixedCls, verticalMenuFixedVisibleCls, verticalMenuItemCls, verticalMenuItemSelectedCls } from "./Menu.less";
var VerticalMenu = /* @__PURE__ */ function(_Component) {
  function VerticalMenu2(props) {
    var _this;
    _classCallCheck(this, VerticalMenu2);
    _this = _callSuper(this, VerticalMenu2, [props]);
    _defineProperty(_this, "handleScroll", function() {
      var _this$menuRef$current = _this.menuRef.current.getBoundingClientRect(), bottom = _this$menuRef$current.bottom;
      _this.setState({
        isFixed: bottom <= 0
      });
    });
    _defineProperty(_this, "handleScrollDebounced", function() {
      clearTimeout(_this.timeoutId);
      _this.timeoutId = setTimeout(_this.handleScroll, _this.props.scrollHandlerTimeout);
    });
    _this.menuRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      isFixed: false
    };
    _this.wasFixedMenuRendered = false;
    return _this;
  }
  __name(VerticalMenu2, "VerticalMenu");
  _inherits(VerticalMenu2, _Component);
  return _createClass(VerticalMenu2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      if (!this.props.disableFixedMenu) {
        var _ref = this.menuRef.current ? this.menuRef.current.getBoundingClientRect() : {}, top = _ref.top;
        this.menuTopOffset = top + window.scrollY - (this.props.correction || 0);
        this.handleScrollDebounced();
        document.addEventListener("scroll", this.handleScrollDebounced, {
          capture: true
        });
      }
    }, "componentDidMount")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      if (!this.props.disableFixedMenu) {
        clearTimeout(this.timeoutId);
        document.removeEventListener("scroll", this.handleScrollDebounced, {
          capture: true
        });
      }
    }, "componentWillUnmount")
  }, {
    key: "render",
    value: (
      /**
       * render
       */
      /* @__PURE__ */ __name(function render() {
        var _this$props = this.props, className = _this$props.className, items = _this$props.items, selectedFixedItem = _this$props.selectedFixedItem, absolutePosition = _this$props.absolutePosition, disableFixedMenu = _this$props.disableFixedMenu, onItemClick = _this$props.onItemClick;
        if (!this.wasFixedMenuRendered && this.state.isFixed) {
          this.wasFixedMenuRendered = true;
        }
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("ul", {
          className: classNames(verticalMenuCls, absolutePosition && verticalMenuAbsoluteCls, className),
          ref: this.menuRef
        }, items.map(function(item) {
          return /* @__PURE__ */ React.createElement("li", {
            key: item.label,
            className: classNames(verticalMenuItemCls, item.selected && verticalMenuItemSelectedCls)
          }, item.url ? /* @__PURE__ */ React.createElement(Link, _extends({
            to: item.url,
            title: item.label,
            type: "strong"
          }, onItemClick ? {
            onClick: onItemClick
          } : null, item.linkProps || {}), item.label) : /* @__PURE__ */ React.createElement("span", null, item.label));
        })), !disableFixedMenu && this.wasFixedMenuRendered ? /* @__PURE__ */ React.createElement("ul", {
          className: classNames(verticalMenuCls, verticalMenuFixedCls, this.state.isFixed && verticalMenuFixedVisibleCls, className),
          style: {
            top: "".concat(this.menuTopOffset, "px")
          }
        }, items.map(function(item) {
          return /* @__PURE__ */ React.createElement("li", {
            key: item.label,
            className: classNames(verticalMenuItemCls, selectedFixedItem === item.key && verticalMenuItemSelectedCls)
          }, item.url ? /* @__PURE__ */ React.createElement(Link, _extends({
            to: item.url,
            title: item.label,
            type: "strong"
          }, onItemClick ? {
            onClick: onItemClick
          } : null), item.label) : /* @__PURE__ */ React.createElement("span", null, item.label));
        })) : null);
      }, "render")
    )
  }]);
}(Component);
_defineProperty(VerticalMenu, "defaultProps", {
  className: null,
  absolutePosition: false,
  disableFixedMenu: false,
  scrollHandlerTimeout: 50,
  correction: 0,
  onItemClick: null
});
export {
  VerticalMenu
};
